import { useState, useEffect } from 'react'

export const useDevice = () => {
    const [device, setDevice] = useState({
        isMobile: false,
        isTablet: false,
        isDesktop: false,
    });

    useEffect(() => {
        
        const handleResize = () => {
        const isMobile = window.matchMedia("(max-width: 768px)").matches
        const isTablet = window.matchMedia("(min-width: 769px) and (max-width: 1024px)").matches
        const isDesktop = window.matchMedia("(min-width: 1025px)").matches

        setDevice({
            isMobile,
            isTablet,
            isDesktop,
        })
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
        window.removeEventListener('resize', handleResize)
    }
  }, [])

  return device
}


